import * as React from 'react'
import * as R from 'ramda'
import {url} from '../../App/AuthenticatedRoute'
import {LinkTableCell} from '../../View/LinkTableCell'
import {
    ProductCalculationOverviewFilterList,
    ProductCalculationOverviewState
} from './ProductCalculationOverviewState'
import {ProductCalculationOverviewAction} from './ProductCalculationOverviewActions'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import IconButton from 'material-ui/IconButton'
import AppBar from 'material-ui/AppBar'
import Table from 'material-ui-next/Table/Table'
import TableHead from 'material-ui-next/Table/TableHead'
import TableRow from 'material-ui-next/Table/TableRow'
import TableCell from 'material-ui-next/Table/TableCell'
import Chip from 'material-ui/Chip'
import TableBody from 'material-ui-next/Table/TableBody'
import ContentFilter from 'material-ui/svg-icons/content/filter-list'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import {ContentAdd} from 'material-ui/svg-icons'
import {ProductCalculationWithAssociations} from '../../Entities/ProductCalculationWithAssociations'
import {ProductCalculationOverviewFilter} from './ProductCalculationOverviewFilter'
import * as Pagination from '../../Data/Pagination'
import {Customer} from '../../Entities/Customer'
import {Footer} from '../../View/Footer'
import {PageSize} from '../../View/PageSize'
import {PaginationView} from '../../View/PaginationView'
import injectSheet from 'react-jss'
import {layers} from '../../Style'

interface Props {
    readonly state: ProductCalculationOverviewState
    readonly dispatch: (action: ProductCalculationOverviewAction) => void
}

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    overviewWrapper: {
        overflow: 'scroll',
        flex: '1'
    },
    navigationBar: {
        height: '128px'
    },
    actionButton: {
        position: 'absolute',
        right: '44px',
        top: '100px',
        zIndex: layers.front
    }
}

export const ProductCalculationOverviewView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => (
            <div className={classes.root}>
                <div className="navigation">
                    <AppBar
                        title="Produktkalkulationen"
                        className={classes.navigationBar}
                        iconElementLeft={
                            <IconButton
                                onTouchTap={() =>
                                    dispatch({
                                        type: 'MenuButtonClicked',
                                    })}
                            >
                                <NavigationMenu/>
                            </IconButton>}
                    />
                </div>
                <div className={`overview ${classes.overviewWrapper}`}>
                    <ProductCalculationOverviewFilter
                        state={state}
                        dispatch={dispatch}
                    />
                    <div
                        className="overview__content"
                    >
                        <FloatingActionButton
                            className={classes.actionButton}
                            href={url({type: 'ProductCalculationImport'})}
                        >
                            <ContentAdd/>
                        </FloatingActionButton>

                        <div
                            style={{
                                display: 'inline-block',
                                height: '48px',
                                paddingLeft: '64px'
                            }}
                        >
                            {
                                showFilterChips(state.filter, dispatch)
                            }
                        </div>

                        <IconButton
                            style={{float: 'right'}}
                            onClick={() => dispatch({
                                type: 'OpenFilter'
                            })}
                        >
                            <ContentFilter/>
                        </IconButton>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{width: '40px'}}>PC-ID</TableCell>
                                    <TableCell>Typ</TableCell>
                                    <TableCell>Format</TableCell>
                                    <TableCell>Umfang</TableCell>
                                    <TableCell>Druck</TableCell>
                                    <TableCell>Papier</TableCell>
                                    <TableCell>Verarbeitung</TableCell>
                                    <TableCell style={{width: '220px'}}>Kunden</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {R.map(
                                    productCalculationWithAssociations =>
                                        ProductCalculationListTableRow(productCalculationWithAssociations),
                                    state.content.data,
                                )}
                            </TableBody>
                        </Table>

                    </div>
                </div>
                <ProductCalculationOverviewFooter
                    content={state.content}
                    dispatch={dispatch}
                />
            </div>
        )
    )

function ProductCalculationListTableRow(productCalculationWithAssociations: ProductCalculationWithAssociations) {
    const href =
        url({
            type: 'ProductCalculationDetails',
            id: productCalculationWithAssociations.productCalculation.id,
        })
    return (
        <TableRow key={productCalculationWithAssociations.productCalculation.id}>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.productCalculation.id}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.typeMessage.translation}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.formatMessage.translation}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.coverageMessage.translation}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.printMessage.translation}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.paperMessage.translation}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {productCalculationWithAssociations.processingMessage.translation}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {customerRenderList(productCalculationWithAssociations.customers)}
            </LinkTableCell>
        </TableRow>
    )
}

function showFilterChips(filter: ProductCalculationOverviewFilterList,
                         dispatch: (action: ProductCalculationOverviewAction) => void) {
    const list = ['type', 'format', 'coverage', 'print', 'paper', 'processing']

    return (
        <div>
            {
                R.map(
                    (currentFilter: string) => {
                        if (filter[currentFilter].value === null) {
                            return <div
                                key={currentFilter + '-chip'}
                                style={{display: 'inline-block'}}
                            />
                        } else {
                            const chipBaseStyle = {
                                border: 'none',
                                display: 'inline-block',
                                marginRight: '16px',
                                marginBottom: '8px'
                            }
                            let resultingChipStyle = {}
                            if (filter[currentFilter].exact) {
                                resultingChipStyle = {
                                    ...chipBaseStyle,
                                    border: '1px solid #000'
                                }
                            } else {
                                resultingChipStyle = chipBaseStyle
                            }
                            return <Chip
                                style={resultingChipStyle}
                                key={currentFilter + '-chip'}
                                onRequestDelete={() => dispatch({
                                    type: 'ClearFilter',
                                    key: currentFilter
                                })}
                            >
                                {getAttributeName(currentFilter)}: {filter[currentFilter].value}
                            </Chip>
                        }
                    },
                    list
                )
            }
        </div>
    )
}

function ProductCalculationOverviewFooter({content, dispatch}: {
    content: Pagination.Pagination<ProductCalculationWithAssociations>
    dispatch: (action: ProductCalculationOverviewAction) => void,
}) {
    return (
        <Footer>
            <PageSize
                itemsPerPage={content.pageSection.itemsPerPage}
                onChange={
                    value => dispatch({
                        type: 'ItemsPerPageChanged',
                        value,
                    })
                }
            />
            <PaginationView
                pagination={content}
                onNavigate={navigation => dispatch({
                    type: 'PaginationNavigation',
                    navigation
                })}
            />
        </Footer>
    )
}

function getAttributeName(key: string): string {
    switch (key) {
        case 'type':
            return 'Typ'
        case 'format':
            return 'Format'
        case 'coverage':
            return 'Umfang'
        case 'print':
            return 'Druck'
        case 'paper':
            return 'Papier'
        case 'processing':
            return 'Verabeitung'
    }
    return ''
}

export function customerRenderList(customers: Customer[]) {
    return R.reduce(
        (acc: string, customer: Customer) => {
            if (acc === '') {
                return customer.longName
            }
            return acc + ', ' + customer.longName
        },
        '',
        customers
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationOverview/ProductCalculationOverviewView.tsx